export const it = {
    'nav.today': "Panoramica Oggi",
    'nav.calendar': "Calendario Domanda",
    'nav.rates': "Tariffe & Regole",
    'nav.automation': "Automazione",
    'nav.audit': "Registro Audit",
    'nav.settings': "Impostazioni",
    'sidebar.status': "Connesso",
    'stat.occupancy': "Occupazione",
    'stat.adr': "ADR (Tariffa Media)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Ricavo Est.",
    'stat.trend.vsLastWeek': "vs Sett. Scorsa",
    'stat.trend.onPace': "In linea",
    'dashboard.actions.title': "Azioni Raccomandate",
    'dashboard.actions.empty': "Nessuna azione trovata.",
    'filter.all': "Tutto",
    'filter.pricing': "Prezzi",
    'filter.restriction': "Restrizioni",
    'action.approve': "Approva",
    'action.reject': "Rifiuta",
    'action.risk.low': "rischio basso",
    'action.risk.medium': "rischio medio",
    'action.risk.high': "rischio alto",
    'action.label.current': "Attuale",
    'action.label.proposed': "Proposto",
    'action.metric.impact': "Impatto",
    'action.metric.why': "Perché",
    'action.status.executed': "Auto-Eseguito",
    'header.search': "Cerca...",
    'header.logout': "Esci",
    'auto.level.title': "Livello Autopilota",
    'auto.level.manual': "Manuale",
    'auto.level.manual.desc': "Approvi ogni singola raccomandazione.",
    'auto.level.assisted': "Assistito",
    'auto.level.assisted.desc': "Auto-approva basso rischio. Revisione modifiche importanti.",
    'auto.level.auto': "Completamente Auto",
    'auto.level.auto.desc': "L'IA gestisce i prezzi 24/7 entro i tuoi limiti.",
    'auto.level.active': "Attivo",
    'auto.guardrails.title': "Limiti di Sicurezza",
    'auto.guardrails.maxIncrease': "Max Aumento Giornaliero",
    'auto.guardrails.maxIncrease.desc': "Evita shock di prezzo.",
    'auto.guardrails.maxDecrease': "Max Diminuzione Giornaliera",
    'auto.guardrails.maxDecrease.desc': "Evita dumping accidentale.",
    'auto.guardrails.minRate': "Tariffa Minima",
    'auto.guardrails.minRate.desc': "Mai vendere sotto questo prezzo (Netto).",
    'auto.emergency.title': "Controllo Emergenza",
    'auto.emergency.label': "Arresto Emergenza",
    'auto.emergency.desc': "Pausa immediata di tutta l'automazione.",
    'auto.emergency.btn': "PAUSA SISTEMA",
    'rates.filter.all': "Tutti i Tipi",
    'rates.filter.next14': "Prossimi 14 Giorni",
    'rates.export': "Esporta",
    'audit.table.time': "Ora",
    'audit.table.actor': "Attore",
    'audit.table.category': "Categoria",
    'audit.table.action': "Azione",
    'audit.table.details': "Dettagli",
    'audit.table.status': "Stato",
    'settings.pms.title': "Connessione PMS",
    'settings.pms.connected': "Connesso a",
    'settings.pms.disconnect': "Disconnetti",
    'settings.account.title': "Account",
    'settings.account.role': "Ruolo",
    'settings.restart': "Riavvia Onboarding",
    'onboard.title': "Connetti PMS",
    'onboard.desc': "Seleziona il tuo gestionale (PMS) per sincronizzare.",
    'onboard.connecting': "Connessione...",
    'onboard.connect': "Connetti",
    'onboard.success.title': "Configurazione Completa!",
    'onboard.success.desc': "**SynthHotel Berlin** è ora sincronizzato.",
    'onboard.success.sub': "Importati 3 tipi di camera, 14 piani tariffari e 243 prenotazioni.",
    'onboard.btn.dashboard': "Vai alla Dashboard",
    'action.dynamic.weekend.title': "Aumenta Tariffa Weekend",
    'action.dynamic.weekend.desc': "Occ. > 75% Sabato, domanda forte (+12 camere in 24h).",
    'action.dynamic.minstay.title': "Attiva Soggiorno Min 2 Notti",
    'action.dynamic.minstay.desc': "Concerto Taylor Swift annunciato. Evita soggiorni di 1 notte.",
    'action.dynamic.distress.title': "Abbassa Tariffa (Bassa Domanda)",
    'action.dynamic.distress.desc': "Occ. 35% Martedì pross. Competitor hanno abbassato di 10€.",
    'action.dynamic.gap.title': "Riempi Vuoto: Rimuovi CTA",
    'action.dynamic.gap.desc': "Notte singola disponibile. Rimuovi 'Chiuso all'Arrivo' per vendere.",
};
